// extracted by mini-css-extract-plugin
export default {"div":"Landing_div__cLWki","video":"Landing_video__8vVR+","h1":"Landing_h1__0aAg4","button":"Landing_button__8MXUf"};